import React, { FC } from 'react';

import { Col, Row } from 'antd';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import ChallengeResourceWrapper, {
  ChallengeResourceWrapperBlocked,
} from 'src/components/challenge/ChallengeResourceWrapper';
import { IRootReducers } from 'src/reducers';
import { ChallengeTypeEnum } from 'src/shared/enums';
import { IChallengeResourceRender, IChallengeText } from 'src/shared/models';

interface OwnProps extends IChallengeResourceRender {
  config: IChallengeText;
}

const mapStateToProps = (state: IRootReducers) => {
  return {
    challenge: state.app.challenge,
    user: state.auth.user,
  };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ChallengeText: FC<Props> = ({ challenge, config, user }) => {
  if (!config) return <React.Fragment />;
  const { description, title, icon, imageDesktop, imagePosition, imageMobile } =
    config;
  const isExperienceOrContest =
    challenge?.challengeType === ChallengeTypeEnum.EXPERIENCE ||
    challenge?.challengeType === ChallengeTypeEnum.CONTEST ||
    challenge?.challengeType === ChallengeTypeEnum.DONATION;
  const hasImage = imageDesktop || imageMobile;

  // TODO - this must be deleted when typeform is refactored
  const hasTypeformButton = description?.indexOf('data-tf-popup') >= 0;
  let typeformInjection;

  if (!isExperienceOrContest) {
    const component = (
      <Row className="challengeVideo" justify="center" align="middle">
        <Row justify="center" className="challengeVideo__videoContainer">
          <ChallengeResourceWrapperBlocked />
        </Row>
      </Row>
    );

    return (
      <ChallengeResourceWrapper
        description={description}
        icon={icon}
        styleClass="challengeDetail--Video"
        title={title}
      >
        {component}
      </ChallengeResourceWrapper>
    );
  }

  let extendedDescription = description;
  const wrapperClassName = classNames(`text-image-resource ${imagePosition}`, {
    'text-image-resource__wrapper--no-image': !imageDesktop && !imageMobile,
    'text-image-resource__wrapper--no-description':
      !description || description.trim() === '',
  });

  if (hasTypeformButton) {
    extendedDescription = extendedDescription
      .replace('{{user_id}}', user.uuidUser)
      .replace('{{email}}', user.email);

    typeformInjection = (
      <Helmet>
        <script src="https://embed.typeform.com/next/embed.js"></script>
      </Helmet>
    );
  }

  return (
    <Row className={wrapperClassName}>
      <Col
        xs={24}
        xl={hasImage ? 12 : 24}
        className={`text-image-resource__text ${imagePosition} ${
          hasImage
            ? 'text-image-resource__text--image'
            : 'text-image-resource__text--no-image'
        }`}
      >
        <div className="content-wrapper">
          <h3>{title}</h3>
          <p
            className="regular-body"
            dangerouslySetInnerHTML={{ __html: extendedDescription }}
          ></p>
        </div>
      </Col>
      {hasImage && (
        <Col xs={24} xl={12} className="text-image-resource__image">
          <img
            loading="lazy"
            src={imageDesktop || imageMobile}
            className="show_on_desktop-bg"
          />
          <img
            loading="lazy"
            src={imageMobile || imageDesktop}
            className="not_show_on_desktop-bg"
          />
        </Col>
      )}
      {typeformInjection}
    </Row>
  );
};

export default connect(mapStateToProps)(ChallengeText);
